import Cosmetology from "../assets/Сosmetology.jpg";
import styles from "./AboutSection.module.scss";

export const AboutSection = () => {
  return (
    <div className={styles.aboutContainer}>
      <div className={styles.aboutWrapper}>
        <div className={styles.aboutWrapper__textBlock}>
          <p className={styles.aboutWrapper__title}>О компании</p>
          <p className={styles.aboutWrapper__text}>
            Наша миссия заключается в предоставлении высококачественных,
            безопасных препаратов и передового оборудования, которые помогут вам
            достичь наилучших результатов в своей работе и повысить уровень
            удовлетворённости и доверия ваших клиентов. Наша цель — вдохновлять
            и помогать вам развиваться, добиваться оптимальных результатов,
            чтобы ваши пациенты доверяли вам, и уходя от вас чувствовали себя
            красивыми и уверенными
          </p>
        </div>
        <div className={styles.aboutWrapper__imgBlock}>
          <img
            src={Cosmetology}
            className={styles.aboutWrapper__img}
            alt="Cosmetology"
          />
        </div>
      </div>
    </div>
  );
};
